import angular from 'angular';
import 'angular-file-saver';

import exportText from './export-text-service';

/**
 * @ngdoc module
 * @name akamai.components.export-text
 * @description Provides users a simple interface to download text.
 * Safari users will have to manually save the file when it opens in a new tab.
 * Files are saved using text/plain;charset=utf-8 MIME type.
 *
 * @param {string} data The data to export to file
 * @param {string} filename The name of file being created. The file extension is required.
 * Default filename is results.txt
 *
 * @returns {Object} Returns a promise which resolves when file downloads
 * successfully else rejects the promise for the developer to handle.
 *
 * @example index.js
 * function ExportCtrl(exportText) {
 *   let filename = 'myFile.txt';
 *   let data = 'This is the text to export to file.';
 *
 *   function exportSomeData(data, filename) {
 *     exportText(data, filename)
 *       .then(function() {
 *         $log.log('File downloaded');
 *       })
 *       .catch(function(error) {
 *         $log.log(error);
 *       });
 *   }
 *
 *   exportSomeData(data, filename);
 * }
 */
export default angular.module('akamai.components.export-text', [
  'ngFileSaver'
])
  .factory('exportText', exportText);
